import SiteNotificationPreferenceSettingsFormFields from '@/features/site/components/settings/notification_preferences/form/SiteNotificationPreferenceSettingsFormFields'

function NotificationPreferencesStep() {
  return <SiteNotificationPreferenceSettingsFormFields />
}

export default NotificationPreferencesStep
